export function formatPhoneE164(phone: string | null): string {
  if (!phone || phone === '') return ''

  let newPhone: string = phone.replace(/\D/g, '')
  newPhone = newPhone.slice(0, 10)

  return '+1' + newPhone
}

export function formatPhoneHuman(phone: string | null): string {
  if (!phone || phone === '') return ''

  const matched = match(phone)
  return matched ? `(${matched[1]}) ${matched[2]}-${matched[3]}` : ''
}

export function formatPhoneAsInput(phone: string | null): string {
  if (!phone || phone === '') return ''

  const matched = match(phone) || matchHuman(phone)
  return matched ? `${matched[1]}-${matched[2]}-${matched[3]}` : ''
}
export function formatE164USPhoneAsHuman(e164phone: string | null): string {
  if (!e164phone) return ''
  const phoneWithoutUSCountryCode = e164phone.replace('+1', '')

  return formatPhoneHuman(phoneWithoutUSCountryCode)
}
function match(phone: string): RegExpMatchArray | null {
  return phone.match(/^(\d{3})(\d{3})(\d{4})$/)
}

function matchHuman(phone: string): RegExpMatchArray | null {
  return phone.match(/^[(](\d{3})[)] (\d{3})-(\d{4})$/)
}
